import React, { useState, useEffect, useMemo } from "react";
import { Modal } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import { storeUser } from "@/store/user";

import CardContent from "@/components/card/CardContent";
import ModalContentRemove from "@components/modals/ModalContentRemove";

import './styles/voiceover-card.scss';

interface Props {
  index?: number;
  isEdit?: boolean;
  data?: any;
  
  remove?: (index: number, item:any) => void;
  edit?: (index, data) => void;
  update: (key: string, value: any) => void;
}

function VoiceoverCard({ remove, index, isEdit, data, update, edit }: Props) {
  const [title, setTitle] = useState<string>('')
  const [activeRemoveItem, setActiveRemoveItem] = useState<any>(null)
  const [isShowModalRemove, setIsShowModalRemove] = useState<boolean>(false)


  const showModalRemove = (index, data) => {
    setActiveRemoveItem({
      index: index,
      data: data
    })
    setIsShowModalRemove(true)
  }

  const acceptRemove = () => {
    setIsShowModalRemove(false)
    remove(activeRemoveItem.index, activeRemoveItem.data)
  }

  const closeModalRemove = () => {
    setIsShowModalRemove(false)
  }

  const setTitleName = () => {
    let name = '';
    
    if(data.voiceoverName) {
      name = data.voiceoverName;
    }

    if(data.name) {
      name = data.name
    }

    const str = `Озвучка: ${name}`;
    setTitle(str)
  }

  useEffect(() => {
    setTitleName()
  }, [data])

  const videoFileName = useMemo(() => {
    if(data?.video_file?.name) {
      return data.video_file.name
    }

    if(data?.video_file_label) {
      return data.video_file_label
    }

    if(data.video_file) {
      if(typeof data.video_file === 'string') {
        return data.video_file
      }

      if(data.vide_file?.name) {
        return data.vide_file.name
      }
    }

    return ''
  }, [data])

  const isActiveText = useMemo(() => {
    if(data.isActive) {
      return 'Да'
    }

    if(data.video_file && data.video_file.status) {
      if(data.video_file.status === "active") {
        return 'Да'
      }
    }

    return 'Нет'
  }, [data])

  const exclusiveInfo = useMemo(() => {
    if (!data.exclusive_until) return null;

    const until = new Date(data.exclusive_until);
    const now = new Date();
    const diffMs = until.getTime() - now.getTime();
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    const isExpired = diffMs <= 0;

    if (isExpired) {
      return { text: 'Завершён', expired: true };
    }

    const daysText = diffDays === 1 ? '1 день' : diffDays < 5 ? `${diffDays} дня` : `${diffDays} дней`;
    return { text: `Активен (ещё ${daysText})`, expired: false };
  }, [data])

  return (
    <div className="voiceover-card">
      <CardContent title={title}>
        <div className="voiceover-card__content">
          <div className="voiceover-card__values">
            <div className={"form-group voiceover-card__advertisement"}>
              <label className={"form-group-label form-group__advert"}>Встроенная реклама:</label>
              { data.has_internal_ads ? 'Есть' : 'Нет' }
            </div>

            <div className={"form-group voiceover-card__advertisement"}>
              <label className={"form-group-label form-group__advert"}>Активный:</label>
              { isActiveText }
            </div>

            <div className={"form-group voiceover-card__advertisement"}>
              <label className={"form-group-label form-group__advert"}>Файл:</label>
              <div className={"text"}>{ videoFileName }</div>
            </div>

            {exclusiveInfo && (
              <div className={"form-group voiceover-card__advertisement"}>
                <label className={"form-group-label form-group__advert"}>Эксклюзивный показ:</label>
                <span className={exclusiveInfo.expired ? "voiceover-card__exclusive--expired" : "voiceover-card__exclusive--active"}>
                  {exclusiveInfo.text}
                </span>
              </div>
            )}
          </div>

          <div className="voiceover-card__control">
            { data.status_id !== 5 && storeUser.isCanRemove && <button className="app-btn-icon delete" onClick={() => showModalRemove(index, data)}>
              <DeleteOutlined />
            </button> }
            { isEdit && <button className="app-btn-icon" onClick={() => edit(index, data)}>
              <EditOutlined />
            </button> }
          </div>
        </div>
      </CardContent>

      <Modal
          title="Удаление озвучки"
          closable={{ "aria-label": "Custom Close Button" }}
          open={isShowModalRemove}
          onOk={acceptRemove}
          onCancel={closeModalRemove}
          okText="Удалить"
          cancelText="Отмена"
      >
        <ModalContentRemove text={`Вы уверены, что хотите удалить озвучку`} />
      </Modal>
    </div>
  );
}

export default VoiceoverCard;
